import React from 'react'
import { Link } from 'gatsby'

import styled from 'styled-components'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax,
} from 'styles/media-queries'
import EtereoLogo from 'icons/etereo-logo.svg'
import StregisLogo from 'icons/stregis-logo.svg'
import EditionLogo from 'icons/edition-logo.svg'
import MOLogo from 'icons/mo-logo.svg'

export const Container = styled.div`
  display: flex;
  position: relative;
  height: 100%;
  ${mediaMax('mobile')} {
    height: 100dvh;
    flex-wrap: wrap;
  }
`
export const Wrap = styled.section`
  height: 100dvh;
`

export const Content = styled.div`
  position: absolute;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  a {
    position: absolute;
    bottom: ${calculateResponsiveSize(30)};
    transform: translateY(${calculateResponsiveSize(55)});
    transition: 0.5s;
  }

  transform: translateY(15%);
  transition: 1.5s;
  .opened & {
    transform: translateY(0%);
  }
  ${mediaMax('mobile')} {
    a {
      bottom: ${calculateMobileResponsiveSize(18)};
      transform: translateY(${calculateResponsiveSize(0)});
    }
  }
`

export const Logo = styled.div`
  width: ${calculateResponsiveSize(156)};
  height: ${calculateResponsiveSize(100)};
  -webkit-mask: url(${EtereoLogo}) no-repeat;
  -webkit-mask-size: contain;
  background: var(--light);
  display: flex;
  transition: 0.5s;
  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(156)};
    height: ${calculateMobileResponsiveSize(100)};
  }
`
export const ImgWrap = styled.div`
  transition: 0.5s;
  & .gatsby-image-wrapper {
    height: 100%;
  }
`
export const Soon = styled.div`
  font-family: 'Canela';
  font-size: ${calculateResponsiveSize(18)};
  font-weight: 300;
  line-height: ${calculateResponsiveSize(28.8)};

  position: absolute;
  bottom: ${calculateResponsiveSize(30)};
  color: var(--light);
  opacity: 0;
  transition: 0.5s;
  ${mediaMax('mobile')} {
    bottom: ${calculateMobileResponsiveSize(13)};
    opacity: 1;
    font-size: ${calculateMobileResponsiveSize(18)};
    font-weight: 300;
    line-height: ${calculateMobileResponsiveSize(28.8)};
  }
`

export const Item = styled.a/* ( (props) => <Link {...props} />) */ `
  display: flex;
  position: relative;
  overflow: hidden;
  width: 25%;
  background: var(--black);

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: black;
    opacity: 0.1;
    transition: 0.5s;
    mix-blend-mode: multiply;
  }
  &:nth-child(2) {
    ${Logo} {
      width: ${calculateResponsiveSize(131)};
      height: ${calculateResponsiveSize(100)};
      -webkit-mask: url(${StregisLogo}) no-repeat;
      -webkit-mask-size: contain;
    }
  }
  &:nth-child(3) {
    ${Logo} {
      width: ${calculateResponsiveSize(172)};
      height: ${calculateResponsiveSize(60)};
      -webkit-mask: url(${EditionLogo}) no-repeat;
      -webkit-mask-size: contain;
    }
  }
  &:nth-child(4) {
    ${Logo} {
      width: ${calculateResponsiveSize(118.6)};
      height: ${calculateResponsiveSize(90)};
      -webkit-mask: url(${MOLogo}) no-repeat;
      -webkit-mask-size: contain;
    }
  }
  &:hover {
    &:after {
      opacity: 0;
    }
    ${ImgWrap} {
      transform: scale(1.13);
    }
    ${Logo} {
      transform: scale(1.13);
    }
    ${Content} {
      a {
        transform: translateY(${calculateResponsiveSize(0)});
      }
    }
    ${Soon} {
      opacity: 1;
    }
  }
  ${mediaMax('mobile')} {
    &:after {
      opacity: 0;
    }
    width: 50%;
    &:nth-child(2) {
      ${Logo} {
        width: ${calculateMobileResponsiveSize(78.7)};
        height: ${calculateMobileResponsiveSize(60)};
      }
    }
    &:nth-child(3) {
      ${Logo} {
        width: ${calculateMobileResponsiveSize(114.5)};
        height: ${calculateMobileResponsiveSize(40)};
      }
    }
    &:nth-child(4) {
      ${Logo} {
        width: ${calculateMobileResponsiveSize(79)};
        height: ${calculateMobileResponsiveSize(60)};
      }
    }
  }
`
